import { render } from "./SettingNotification.vue?vue&type=template&id=f6d26950&scoped=true&ts=true"
import script from "./SettingNotification.vue?vue&type=script&lang=ts"
export * from "./SettingNotification.vue?vue&type=script&lang=ts"

import "./SettingNotification.vue?vue&type=style&index=0&id=f6d26950&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d26950"]])

export default __exports__